/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { guidFor } from "@ember/object/internals";
import Component from "@glimmer/component";
import { EmberChangeset } from "ember-changeset";
import { validatePresence } from "ember-changeset-validations/validators";
export default class FormyFieldComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "id", guidFor(this));
    _defineProperty(this, "private", void 0);
  }
  get error() {
    const error = this.args.formy.args.changeset.error[this.args.key];
    if (!error) return;
    const errors = error.validation;
    if (!errors) return;
    return errors instanceof Array ? errors[0] : errors;
  }
  get errorId() {
    if (!this.error) return undefined;
    return guidFor(this.error);
  }
  _isPresenceValidation(validation) {
    return validation.toString() === validatePresence().toString();
  }
}